<template>
  <div class="inspetor-no">
    <div class="d-flex justify-content-between align-items-center p-1 border-bottom">
      <strong>{{ rotuloTipo }}</strong>
      <div>
        <button class="btn btn-sm btn-outline-danger mr-1" title="Remover nó" @click="$emit('remover')">
          <i class="fa fa-trash"></i>
        </button>
        <button class="btn btn-sm btn-outline-secondary" title="Fechar" @click="$emit('fechar')">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <div class="p-1">
      <small class="text-muted d-block mb-1">{{ descricaoTipo }}</small>

      <template v-if="no.tipo === 'inicio'">
        <p class="text-muted">Ponto de entrada do fluxo - sem configuração.</p>
      </template>

      <template v-else-if="no.tipo === 'mensagem' || no.tipo === 'captura'">
        <label>Texto <small class="text-muted" v-pre>(use {{contato.nome}} pra interpolar)</small></label>
        <textarea class="form-control mb-1" rows="3" v-model="local.texto"></textarea>
        <template v-if="no.tipo === 'captura'">
          <label>Guardar resposta na variável:</label>
          <input type="text" class="form-control" v-model="local.nome_variavel" placeholder="ex: nome_cliente" />
        </template>
      </template>

      <template v-else-if="no.tipo === 'botoes'">
        <label>Texto</label>
        <textarea class="form-control mb-1" rows="3" v-model="local.texto"></textarea>
        <label>
          Botões (máx. 3, título até 20 caracteres)
        </label>
        <div v-for="(botao, indice) in local.botoes" :key="indice" class="input-group mb-50">
          <input type="text" class="form-control" maxlength="20" v-model="botao.titulo" placeholder="Título do botão" />
          <div class="input-group-append">
            <button class="btn btn-outline-danger" @click="local.botoes.splice(indice, 1)"><i class="fa fa-times"></i></button>
          </div>
        </div>
        <button v-if="local.botoes.length < 3" class="btn btn-sm btn-outline-primary" @click="adicionarBotao">
          + Adicionar botão
        </button>
      </template>

      <template v-else-if="no.tipo === 'lista'">
        <label>Texto</label>
        <textarea class="form-control mb-1" rows="3" v-model="local.texto"></textarea>
        <label>Texto do botão da lista:</label>
        <input type="text" class="form-control mb-1" maxlength="20" v-model="local.texto_botao" />
        <label>Título da seção <small class="text-muted">(opcional)</small>:</label>
        <input type="text" class="form-control mb-1" maxlength="24" v-model="local.secoes[0].titulo" />
        <label>Linhas (máx. 10)</label>
        <div v-for="(linha, indice) in linhas" :key="indice" class="input-group mb-50">
          <input type="text" class="form-control" maxlength="24" v-model="linha.titulo" placeholder="Título da linha (máx. 24)" />
          <div class="input-group-append">
            <button class="btn btn-outline-danger" @click="linhas.splice(indice, 1)"><i class="fa fa-times"></i></button>
          </div>
        </div>
        <button v-if="linhas.length < 10" class="btn btn-sm btn-outline-primary" @click="adicionarLinha">
          + Adicionar linha
        </button>
      </template>

      <template v-else-if="no.tipo === 'imagem'">
        <label>Imagem (JPG ou PNG, até 5MB)</label>
        <div v-if="previewUrl" class="mb-50">
          <img :src="previewUrl" class="inspetor-imagem-preview" :alt="local.nome_arquivo" />
          <small class="text-muted d-block">{{ local.nome_arquivo }}</small>
        </div>
        <input
          ref="arquivoImagem"
          type="file"
          accept="image/jpeg,image/png"
          class="form-control-file mb-1"
          :disabled="enviandoImagem"
          @change="enviarImagem"
        />
        <small v-if="enviandoImagem" class="text-muted d-block mb-1">Enviando...</small>
        <label>Legenda <small class="text-muted" v-pre>(opcional, aceita {{contato.nome}})</small></label>
        <textarea class="form-control" rows="2" v-model="local.legenda"></textarea>
      </template>

      <template v-else-if="no.tipo === 'unidade'">
        <label>Pergunta</label>
        <textarea class="form-control mb-1" rows="3" v-model="local.texto"></textarea>
        <label>Mensagem quando o código não existe:</label>
        <textarea class="form-control mb-1" rows="2" v-model="local.texto_invalido"></textarea>
        <label>Tentativas antes de seguir por "Não encontrada":</label>
        <input type="number" min="1" class="form-control mb-1" v-model.number="local.max_tentativas" />
        <small class="text-muted d-block" v-pre>
          O código é o "Código do cliente" do cadastro de unidades. Quando válido, o atendimento fica vinculado à unidade e as variáveis {{unidade_codigo}} e {{unidade_nome}} ficam disponíveis.
        </small>
      </template>

      <template v-else-if="no.tipo === 'chamado_glpi'">
        <label>Tipo</label>
        <select class="form-control mb-1" v-model.number="local.tipo">
          <option :value="1">Incidente</option>
          <option :value="2">Requisição</option>
        </select>
        <label>Título <small class="text-muted" v-pre>(aceita {{unidade_nome}}, {{contato.nome}}...)</small></label>
        <input type="text" class="form-control mb-1" maxlength="255" v-model="local.titulo" />
        <label>Descrição <small class="text-muted" v-pre>(ex: {{descricao_problema}} de uma Captura)</small></label>
        <textarea class="form-control mb-50" rows="3" v-model="local.descricao"></textarea>
        <div class="custom-control custom-checkbox mb-1">
          <input id="incluir-conversa" type="checkbox" class="custom-control-input" v-model="local.incluir_conversa" />
          <label class="custom-control-label" for="incluir-conversa">Incluir a conversa do atendimento na descrição</label>
        </div>
        <label>Categoria <small class="text-muted">(opcional)</small></label>
        <v-select
          class="mb-25"
          :options="categoriasDoTipo"
          label="nome_completo"
          :reduce="categoria => categoria.id"
          :value="local.categoria_id"
          :loading="carregandoGlpi"
          placeholder="Sem categoria"
          @input="escolherCategoria"
        >
          <template #no-options>Nenhuma categoria</template>
        </v-select>
        <small v-if="erroGlpi" class="text-danger d-block mb-1">{{ erroGlpi }}</small>
        <small v-else class="text-muted d-block mb-1">Só aparecem as categorias habilitadas para o tipo escolhido.</small>
        <label>Abrir o chamado como</label>
        <select class="form-control mb-1" v-model="local.abrir_como">
          <option value="aberto">Aberto (o operador atende no GLPI)</option>
          <option value="solucionado">Solucionado</option>
          <option value="fechado">Fechado</option>
        </select>
        <template v-if="local.abrir_como === 'solucionado' || local.abrir_como === 'fechado'">
          <label>Solução <small class="text-muted">(registrada no chamado, aceita variáveis)</small></label>
          <textarea class="form-control mb-1" rows="2" v-model="local.solucao"></textarea>
        </template>
        <label>Urgência</label>
        <select class="form-control mb-1" v-model.number="local.urgencia">
          <option v-for="urgencia in urgencias" :key="urgencia.valor" :value="urgencia.valor">{{ urgencia.rotulo }}</option>
        </select>
        <label>Entidade quando o atendimento não tem unidade <small class="text-muted">(opcional)</small></label>
        <v-select
          class="mb-1"
          :options="entidadesGlpi"
          label="nome_completo"
          :reduce="entidade => entidade.id"
          v-model="local.entidade_id"
          placeholder="Entidade padrão do usuário da API"
        />
        <template v-if="camposGlpi.length">
          <hr class="my-1" />
          <strong class="d-block mb-50">Campos adicionais do GLPI</strong>
          <div v-for="campo in camposGlpi" :key="campo.chave_input" class="mb-1">
            <label>
              <span v-if="campo.obrigatorio" class="text-danger">*</span> {{ campo.rotulo }}
              <small v-if="camposGlpiDeVariosBlocos" class="text-muted">({{ campo.container }})</small>
            </label>
            <v-select
              v-if="campo.tipo === 'lista'"
              :options="campo.opcoes"
              label="nome"
              :reduce="opcao => opcao.id"
              v-model="valoresCamposGlpi[campo.chave_input]"
              placeholder="Não preencher"
            />
            <input
              v-else
              type="text"
              class="form-control"
              v-model="valoresCamposGlpi[campo.chave_input]"
              :placeholder="'ex: {{contato.nome}}'"
            />
          </div>
          <small class="text-muted d-block mb-1">
            Campos com * são obrigatórios no GLPI. Os de texto aceitam variáveis.
          </small>
        </template>
        <hr class="my-1" />
        <strong class="d-block mb-50">Mensagens ao contato <small class="text-muted">(deixe vazio para não enviar)</small></strong>
        <label>Antes de abrir o chamado</label>
        <textarea class="form-control mb-1" rows="2" v-model="local.mensagem_aguarde"></textarea>
        <label>Chamado aberto <small class="text-muted" v-pre>(use #{{glpi_chamado_id}} para o número)</small></label>
        <textarea class="form-control mb-1" rows="2" v-model="local.mensagem_sucesso"></textarea>
        <label>Quando o GLPI não responder</label>
        <textarea class="form-control mb-1" rows="2" v-model="local.mensagem_falha"></textarea>
        <small class="text-muted d-block" v-pre>
          A localização e a entidade do chamado vêm da unidade do atendimento (bloco "Identificar unidade"). Se o chamado abrir, {{glpi_chamado_id}} também fica disponível para os próximos blocos. Se o GLPI falhar, o fluxo segue por "Falhou", o sistema tenta abrir de novo em segundo plano e, quando conseguir, envia a mensagem de "Chamado aberto" ao contato.
        </small>
      </template>

      <template v-else-if="no.tipo === 'condicao'">
        <label>Variável:</label>
        <input type="text" class="form-control mb-1" v-model="local.variavel" placeholder="ex: nome_cliente" />
        <label>Operador:</label>
        <select class="form-control mb-1" v-model="local.operador">
          <option value="igual">Igual a</option>
          <option value="diferente">Diferente de</option>
          <option value="contem">Contém</option>
        </select>
        <label>Valor:</label>
        <input type="text" class="form-control" v-model="local.valor" />
      </template>

      <template v-else-if="no.tipo === 'horario' || no.tipo === 'transferir'">
        <label>Departamento:</label>
        <select class="form-control" v-model="local.departamento_id">
          <option :value="null">Selecione...</option>
          <option v-for="dep in departamentos" :key="dep.id" :value="dep.id">{{ dep.nome }}</option>
        </select>
      </template>

      <template v-else-if="no.tipo === 'aguardar'">
        <label>Aguardar quantos segundos:</label>
        <input type="number" min="1" class="form-control" v-model.number="local.segundos" />
      </template>

      <template v-else-if="no.tipo === 'fim'">
        <p class="text-muted">Encerra o atendimento sem transferir - sem configuração.</p>
      </template>

      <template v-else-if="no.tipo === 'nota'">
        <label>Anotação (não é executada pelo motor):</label>
        <textarea class="form-control" rows="3" v-model="local.texto"></textarea>
      </template>

      <button class="btn btn-primary btn-block mt-1" @click="aplicar">
        Aplicar
      </button>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { TEXTOS_PADRAO_CHAMADO, SOLUCAO_PADRAO_CHAMADO } from '@/utils/fluxoSchema'

const URGENCIAS = [
  { valor: 1, rotulo: 'Muito baixa' },
  { valor: 2, rotulo: 'Baixa' },
  { valor: 3, rotulo: 'Média' },
  { valor: 4, rotulo: 'Alta' },
  { valor: 5, rotulo: 'Muito alta' },
]

export default {
  components: { vSelect },
  props: {
    no: { type: Object, required: true },
    catalogo: { type: Array, default: () => [] },
    departamentos: { type: Array, default: () => [] },
    fluxoId: { type: [Number, String], default: null },
  },
  data() {
    return {
      local: {},
      linhas: [],
      previewUrl: null,
      enviandoImagem: false,
      categoriasGlpi: [],
      camposGlpi: [],
      valoresCamposGlpi: {},
      entidadesGlpi: [],
      carregandoGlpi: false,
      erroGlpi: null,
      urgencias: URGENCIAS,
    }
  },
  computed: {
    infoTipo() {
      return this.catalogo.find(c => c.tipo === this.no.tipo) || {}
    },
    rotuloTipo() {
      return this.infoTipo.rotulo || this.no.tipo
    },
    descricaoTipo() {
      return this.infoTipo.descricao || ''
    },
    camposGlpiDeVariosBlocos() {
      return new Set(this.camposGlpi.map(c => c.container_id)).size > 1
    },
    categoriasDoTipo() {
      const requisicao = Number(this.local.tipo) === 2
      return this.categoriasGlpi.filter(c => (requisicao ? c.requisicao : c.incidente) || c.id === this.local.categoria_id)
    },
  },
  watch: {
    'no.id': {
      immediate: true,
      handler() {
        this.local = JSON.parse(JSON.stringify(this.no.conteudo || {}))
        if (this.no.tipo === 'botoes' && !this.local.botoes) this.local.botoes = []
        if (this.no.tipo === 'lista') {
          if (!this.local.secoes || !this.local.secoes.length) this.local.secoes = [{ titulo: '', linhas: [] }]
          this.linhas = this.local.secoes[0].linhas
        }
        this.previewUrl = null
        if (this.no.tipo === 'imagem' && this.local.midia_id) this.carregarPreview(this.local.midia_id)
        if (this.no.tipo === 'chamado_glpi') {
          // no criado antes das mensagens existirem: mostra o padrao que o motor usaria
          Object.keys(TEXTOS_PADRAO_CHAMADO).forEach(campo => {
            if (this.local[campo] === undefined || this.local[campo] === null) this.$set(this.local, campo, TEXTOS_PADRAO_CHAMADO[campo])
          })
          if (!this.local.abrir_como) this.$set(this.local, 'abrir_como', 'aberto')
          if (this.local.solucao === undefined) this.$set(this.local, 'solucao', SOLUCAO_PADRAO_CHAMADO)
          this.valoresCamposGlpi = (this.local.campos_glpi || []).reduce((acc, campo) => {
            acc[campo.chave_input] = campo.valor
            return acc
          }, {})
          this.garantirChavesCamposGlpi()
          this.carregarListasGlpi()
        }
      },
    },
  },
  methods: {
    // Categorias vem direto do GLPI (cache de 10 min no backend); entidades
    // da copia local sincronizada.
    carregarListasGlpi() {
      if (this.categoriasGlpi.length || this.carregandoGlpi) return
      this.carregandoGlpi = true
      this.erroGlpi = null
      Promise.all([
        window.axios.get(this.$store.state.api + 'glpi/categorias')
          .then(resposta => { this.categoriasGlpi = resposta.data.data })
          .catch(error => { this.erroGlpi = 'Não foi possível carregar as categorias do GLPI: ' + ((error.response && error.response.data) || error.message) }),
        window.axios.get(this.$store.state.api + 'glpi/entidades')
          .then(resposta => { this.entidadesGlpi = resposta.data.data })
          .catch(() => { this.entidadesGlpi = [] }),
        window.axios.get(this.$store.state.api + 'glpi/campos-chamado')
          .then(resposta => {
            this.camposGlpi = resposta.data.data
            this.garantirChavesCamposGlpi()
          })
          .catch(() => { this.camposGlpi = [] }),
      ]).finally(() => { this.carregandoGlpi = false })
    },
    // Vue 2 so reage a chave que ja existe no objeto
    garantirChavesCamposGlpi() {
      this.camposGlpi.forEach(campo => {
        if (!(campo.chave_input in this.valoresCamposGlpi)) this.$set(this.valoresCamposGlpi, campo.chave_input, null)
      })
    },
    escolherCategoria(categoriaId) {
      const categoria = this.categoriasGlpi.find(c => c.id === categoriaId)
      this.local = { ...this.local, categoria_id: categoriaId || null, categoria_nome: categoria ? categoria.nome_completo : '' }
    },
    adicionarBotao() {
      this.local.botoes.push({ id: 'b' + (Date.now() % 100000), titulo: '' })
    },
    adicionarLinha() {
      this.linhas.push({ id: 'l' + (Date.now() % 100000), titulo: '', descricao: '' })
    },
    // A URL assinada expira em 1h - por isso nao fica salva no conteudo do
    // no, busca de novo cada vez que o inspetor abre.
    carregarPreview(midiaId) {
      window.axios.get(this.$store.state.api + 'fluxo-midias/' + midiaId)
        .then(resposta => { this.previewUrl = resposta.data.url_assinada })
        .catch(() => { this.previewUrl = null })
    },
    async enviarImagem(evento) {
      const arquivo = evento.target.files[0]
      if (!arquivo) return

      const dadosFormulario = new FormData()
      dadosFormulario.append('arquivo', arquivo)
      if (this.fluxoId) dadosFormulario.append('fluxo_id', this.fluxoId)

      this.enviandoImagem = true
      try {
        const resposta = await window.axios.post(this.$store.state.api + 'fluxo-midias', dadosFormulario)
        this.local = { ...this.local, midia_id: resposta.data.id, nome_arquivo: resposta.data.nome_original }
        this.previewUrl = resposta.data.url_assinada
      } catch (error) {
        this.$error(error)
      } finally {
        this.enviandoImagem = false
        this.$refs.arquivoImagem.value = ''
      }
    },
    aplicar() {
      if (this.no.tipo === 'lista') {
        this.local.secoes = [{ titulo: this.local.secoes[0].titulo || '', linhas: this.linhas }]
      }
      // Sem a lista do GLPI (falhou ao carregar) mantem o que ja estava.
      // Guarda chave/rotulo/tipo junto do valor: o motor monta o chamado
      // sem consultar o GLPI de novo.
      if (this.no.tipo === 'chamado_glpi' && this.camposGlpi.length) {
        const preenchido = valor => valor !== null && valor !== undefined && String(valor).trim() !== ''
        this.local.campos_glpi = this.camposGlpi
          .filter(campo => preenchido(this.valoresCamposGlpi[campo.chave_input]))
          .map(campo => {
            const valor = this.valoresCamposGlpi[campo.chave_input]
            const opcao = campo.tipo === 'lista' ? campo.opcoes.find(o => o.id === valor) : null
            return {
              container_id: campo.container_id,
              chave_input: campo.chave_input,
              rotulo: campo.rotulo,
              tipo: campo.tipo,
              multiplo: campo.multiplo,
              valor,
              valor_rotulo: opcao ? opcao.nome : valor,
            }
          })
        this.local.campos_glpi_obrigatorios = this.camposGlpi
          .filter(campo => campo.obrigatorio)
          .map(campo => ({ chave_input: campo.chave_input, rotulo: campo.rotulo }))
      }
      this.$emit('atualizar', JSON.parse(JSON.stringify(this.local)))
    },
  },
}
</script>

<style scoped>
.inspetor-no {
  height: 100%;
  overflow-y: auto;
}
.inspetor-imagem-preview {
  max-width: 100%;
  max-height: 180px;
  border-radius: 4px;
  border: 1px solid #e4e4e4;
}
</style>
